// baseurl.js

// Backend API base URL
// export const baseurl = "http://127.0.0.1:8000/api/"; 
export const baseurl = "https://pharmabackend.devbhoomipainrelief.com/api/"; 

// Image base URL (for static uploads)
export const imgurl = "http://127.0.0.1:8000/"; 
